import HiveContext from "contexts/HiveContext";
import { useContext } from "react";

const useHive = () => useContext(HiveContext);

export default useHive;
